import { render, staticRenderFns } from "./module-skeleton.vue?vue&type=template&id=7b1ce11c&scoped=true&"
import script from "./module-skeleton.vue?vue&type=script&lang=ts&setup=true&"
export * from "./module-skeleton.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./module-skeleton.vue?vue&type=style&index=0&id=7b1ce11c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1ce11c",
  null
  
)

export default component.exports